<template>
  <div>
    <a-card style="margin: 10px 0">
      <div class="filter-section">
        <a-form layout="inline" ref="form" :model="form" class="dataform-search" style="width: 100%">
          <!-- <a-form-item label="筛选数量" name="pageSizeMax">
            <a-input-number v-model:value="form.pageSizeMax" :min="0" :max="999999" :precision="0" :step="1" />
          </a-form-item> -->
          <a-form-item label="日期" name="minDate">
            <a-date-picker style="width: 120px" valueFormat="YYYY-MM-DD 00:00:00" v-model:value="form.minDate"
              :allowClear="false" />
          </a-form-item>
          <a-form-item label="至" name="maxDate" :labelCol="{span: 4}" :colon="false">
            <a-date-picker style="width: 120px" valueFormat="YYYY-MM-DD 23:59:59" v-model:value="form.maxDate"
              :allowClear="false" />
          </a-form-item>
          <a-form-item name="uploadRecordId">
            <a-input style="width: 180px" placeholder="请输入上传ID号" v-model:value="itemAddition.uploadRecordId"
              autocomplete="off">
              <template v-slot:suffix>
                <search-outlined type="user" />
              </template>
            </a-input>
          </a-form-item>
          <a-form-item label="是否添加数据集" name="existDatasetState">
            <a-select style="width: 140px" v-model:value="itemAddition.existDatasetState">
              <a-select-option key="">
                全部
              </a-select-option>
              <a-select-option key="success">
                是
              </a-select-option>
              <a-select-option key="failure">
                否
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="数据属性">
            <a-tree-select 
              v-model:value="attrValue" 
              style="width: 120px" 
              treeNodeLabelProp="chineseInstructions"
              :tree-data="dataAttrData" 
              tree-checkable 
              search-placeholder="请选择" 
            />
          </a-form-item>
         
          <a-form-item label="矩形框标注" style="margin-left: 20px;"> <!--目标检测标注&&矩形框标注 -->
            <a-select v-model:value="itemAddition.objectDetectionTaskState">
              <a-select-option key="">全部</a-select-option>
              <a-select-option key="success">是</a-select-option>
              <a-select-option key="failure">否</a-select-option>
            </a-select>
          </a-form-item>
        
          <a-form-item label="labelme" style="margin-left: 20px;">  <!--多边形标注 -->
            <a-select v-model:value="itemAddition.polygonTaskState">
              <a-select-option key="">全部</a-select-option>
              <a-select-option key="success">是</a-select-option>
              <a-select-option key="failure">否</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="tag筛选">
                <a-select mode="multiple" style="width: 120px" v-model:value="tagValue" placeholder="请选择">
                  <a-select-option v-for="i in allTags" :key="i.id" :value="i.chineseInstructions">
                    {{i.chineseInstructions}}
                  </a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item label="label内容查询" style="margin-left:20px;">
                <!-- <a-input v-model:value="itemAddition.labelNames" /> -->
                <a-select 
                  v-model:value="labels"
                  mode="tags"
                  style="width:100%"
                  placeholder="请添加" 
                >
                </a-select>
   
              </a-form-item>
              <a-form-item label="label数量查询">
                <a-input-number v-model:value="itemAddition.minLabelCount" :min="0" :max="999999" :precision="0"
                  @blur='numMaxCheck' :step="1" /> -&nbsp;&nbsp;
                <a-input-number v-model:value="itemAddition.maxLabelCount" :min="0" :max="999999" :precision="0"
                  @blur='numMinCheck' :step="1" />
              </a-form-item>
          <!-- <a-form-item label="数据类型" name="itemTypeId">
            <a-select style="width: 140px" v-model:value="itemAddition.itemTypeId">
              <a-select-option key="">
                全部
              </a-select-option>
              <a-select-option v-for="t in dataTypeList" :key="t.id">
                {{ t.chineseInstructions }}
              </a-select-option>
            </a-select>
          </a-form-item> -->
          <a-collapse v-if="false" class="filter-collapse" :bordered="false" expand-icon-position="right" style="width:100%;margin-top: 5px;">
            <a-collapse-panel key="1" header="展开更多条件" :forceRender="true">
              <!-- <a-form-item label="自动分类标注">
                <a-select v-model:value="itemAddition.autoClassficationTaskState">
                  <a-select-option key="">全部</a-select-option>
                  <a-select-option key="success">是</a-select-option>
                  <a-select-option key="failure">否</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item label="自动实例分割标注">
                <a-select v-model:value="itemAddition.autoInstanceSegmentationTaskState">
                  <a-select-option key="">全部</a-select-option>
                  <a-select-option key="success">是</a-select-option>
                  <a-select-option key="failure">否</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item label="自动目标检测标注&矩形框标注">
                <a-select v-model:value="itemAddition.autoObjectDetectionTaskState">
                  <a-select-option key="">全部</a-select-option>
                  <a-select-option key="success">是</a-select-option>
                  <a-select-option key="failure">否</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item label="自动全景分割标注">
                <a-select v-model:value="itemAddition.autoPanopticSegmentationTaskState">
                  <a-select-option key="">全部</a-select-option>
                  <a-select-option key="success">是</a-select-option>
                  <a-select-option key="failure">否</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item label="自动多边形标注">
                <a-select v-model:value="itemAddition.autoPolygonTaskState">
                  <a-select-option key="">全部</a-select-option>
                  <a-select-option key="success">是</a-select-option>
                  <a-select-option key="failure">否</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item label="自动语义分割标注">
                <a-select v-model:value="itemAddition.autoSemanticSegmentationTaskState">
                  <a-select-option key="">全部</a-select-option>
                  <a-select-option key="success">是</a-select-option>
                  <a-select-option key="failure">否</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item label="自动tag标注">
                <a-select v-model:value="itemAddition.autoTagAnnotationTaskState">
                  <a-select-option key="">全部</a-select-option>
                  <a-select-option key="success">是</a-select-option>
                  <a-select-option key="failure">否</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item label="自动其他标注">
                <a-select v-model:value="itemAddition.autoOtherAnnotationTaskState">
                  <a-select-option key="">全部</a-select-option>
                  <a-select-option key="success">是</a-select-option>
                  <a-select-option key="failure">否</a-select-option>
                </a-select>
              </a-form-item> -->
              <!-- <a-form-item label="分类标注">
                <a-select v-model:value="itemAddition.classficationTaskState">
                  <a-select-option key="">全部</a-select-option>
                  <a-select-option key="success">是</a-select-option>
                  <a-select-option key="failure">否</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item label="实例分割标注">
                <a-select v-model:value="itemAddition.instanceSegmentationTaskState">
                  <a-select-option key="">全部</a-select-option>
                  <a-select-option key="success">是</a-select-option>
                  <a-select-option key="failure">否</a-select-option>
                </a-select>
              </a-form-item> -->
              <a-form-item label="矩形框标注"> <!--目标检测标注&&矩形框标注 -->
                <a-select v-model:value="itemAddition.objectDetectionTaskState">
                  <a-select-option key="">全部</a-select-option>
                  <a-select-option key="success">是</a-select-option>
                  <a-select-option key="failure">否</a-select-option>
                </a-select>
              </a-form-item>
              <!-- <a-form-item label="全景分割标注">
                <a-select v-model:value="itemAddition.panopticSegmentationTaskState">
                  <a-select-option key="">全部</a-select-option>
                  <a-select-option key="success">是</a-select-option>
                  <a-select-option key="failure">否</a-select-option>
                </a-select>
              </a-form-item> -->
              <!-- <a-form-item label="点云标注">
                <a-select v-model:value="itemAddition.pointCloudAnnotationTaskState">
                  <a-select-option key="">全部</a-select-option>
                  <a-select-option key="success">是</a-select-option>
                  <a-select-option key="failure">否</a-select-option>
                </a-select>
              </a-form-item> -->
              <a-form-item label="labelme">  <!--多边形标注 -->
                <a-select v-model:value="itemAddition.polygonTaskState">
                  <a-select-option key="">全部</a-select-option>
                  <a-select-option key="success">是</a-select-option>
                  <a-select-option key="failure">否</a-select-option>
                </a-select>
              </a-form-item>
              <!-- <a-form-item label="语义分割标注">
                <a-select v-model:value="itemAddition.semanticSegmentationTaskState">
                  <a-select-option key="">全部</a-select-option>
                  <a-select-option key="success">是</a-select-option>
                  <a-select-option key="failure">否</a-select-option>
                </a-select>
              </a-form-item> -->
              <!-- <a-form-item label="语音标注">
                <a-select v-model:value="itemAddition.speechAnnotationTaskState">
                  <a-select-option key="">全部</a-select-option>
                  <a-select-option key="success">是</a-select-option>
                  <a-select-option key="failure">否</a-select-option>
                </a-select>
              </a-form-item> -->
              <!-- <a-form-item label="tag标注">
                <a-select v-model:value="itemAddition.tagAnnotationTaskState">
                  <a-select-option key="">全部</a-select-option>
                  <a-select-option key="success">是</a-select-option>
                  <a-select-option key="failure">否</a-select-option>
                </a-select>
              </a-form-item> -->
              <!-- <a-form-item label="文本标注">
                <a-select v-model:value="itemAddition.textAnnotationTaskState">
                  <a-select-option key="">全部</a-select-option>
                  <a-select-option key="success">是</a-select-option>
                  <a-select-option key="failure">否</a-select-option>
                </a-select>
              </a-form-item> -->
              <!-- <a-form-item label="视频标注">
                <a-select v-model:value="itemAddition.videoAnnotationTaskState">
                  <a-select-option key="">全部</a-select-option>
                  <a-select-option key="success">是</a-select-option>
                  <a-select-option key="failure">否</a-select-option>
                </a-select>
              </a-form-item> -->
              <!-- <a-form-item label="其他标注">
                <a-select v-model:value="itemAddition.otherAnnotationTaskState">
                  <a-select-option key="">全部</a-select-option>
                  <a-select-option key="success">是</a-select-option>
                  <a-select-option key="failure">否</a-select-option>
                </a-select>
              </a-form-item> -->
              <a-form-item label="tag筛选">
                <a-select mode="multiple" style="width: 120px" v-model:value="tagValue" placeholder="请选择">
                  <a-select-option v-for="i in allTags" :key="i.id" :value="i.chineseInstructions">
                    {{i.chineseInstructions}}
                  </a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item label="label内容查询" style="margin-left:20px;">
                <!-- <a-input v-model:value="itemAddition.labelNames" /> -->
                <a-select 
                  v-model:value="labels"
                  mode="tags"
                  style="width:100%"
                  placeholder="请添加" 
                >
                </a-select>
                <!-- <div  
                  style="display:inline-flex;  flex-wrap: wrap;border:1px solid #ccc; width: 300px;height: 35px;background:#fff; overflow-y: auto; padding:5px;">

                  <template v-for="(tag, index) in tags" :key="tag">
                    <a-tooltip v-if="tag.length > 20" :key="tag" :title="tag">
                      <a-tag :key="tag" :closable="index !== 0" @close="() => handleClose(tag)">
                        {{ `${tag.slice(0, 20)}...` }}
                      </a-tag>
                    </a-tooltip>
                    <a-tag v-else :closable="true" @close="() => handleClose(tag)">
                      {{ tag }}
                    </a-tag>
                  </template>

                </div>

                <div style="display:inline-block; vertical-align: top;position: relative;top: -3px;">
                  <a-input v-if="inputVisible" ref="input" type="text" size="small"
                    :style="{ width: '78px',marginLeft:'5px' }" :value="inputValue" @change="handleInputChange"
                    @blur="handleInputConfirm" @keyup.enter="handleInputConfirm" />
                  <a-tag v-else style="background: #fff; borderStyle: dashed; margin-left:5px;" @click="showInput">
                    <plus-outlined />添加label
                  </a-tag>
                </div>  -->


                <!-- <a-input v-if="inputVisible" ref="inputRef" type="text" size="small" :style="{ width: '78px' }"
                  v-model:value="inputValue" @blur="handleInputConfirm" @keyup.enter="handleInputConfirm" />
                <a-tag v-else @click="showInput" style="background: #fff; border-style: dashed">
                  <plus-outlined />
                  New Tag
                </a-tag> -->
              </a-form-item>
              <a-form-item label="label数量查询">
                <a-input-number v-model:value="itemAddition.minLabelCount" :min="0" :max="999999" :precision="0"
                  @blur='numMaxCheck' :step="1" /> -&nbsp;&nbsp;
                <a-input-number v-model:value="itemAddition.maxLabelCount" :min="0" :max="999999" :precision="0"
                  @blur='numMinCheck' :step="1" />
              </a-form-item>

            </a-collapse-panel>
          </a-collapse>
          <div style="margin-top: 10px">
            <a-button @click="resetForm">重置</a-button>
            <a-button type="primary" @click="searchHandle">查询</a-button>
          </div>
        </a-form>
      </div>
    </a-card>
    <a-card>
      <div class="table-title">
        <p class="table-name">数据列表</p>
        <a-button style="margin-right: 10px" type="primary" @click="openAddDataSet"
          v-if="btnPerm.dataset.add.indexOf(currentRole.roleId) !== -1" >创建数据集</a-button>
      </div>
      <a-table :columns="columns" :data-source="tableData" rowKey="id" :pagination="false" :loading="searchloading">
        <template v-slot:itemType="{ text }">
          {{ getDataTypeName(text) }}
        </template>
        <template v-slot:time="{ text }">
          {{ getDateTime(text) }}
        </template>
        <template v-slot:action="{ record }">
          <span>
            <a @click="handlePreview(record)">预览</a>
            <a-divider type="vertical" />
            <a @click="openDetail(record)">查看</a>
          </span>
        </template>
      </a-table>
      <br>
      <!-- <a-pagination :current="page.pageNum" show-quick-jumper :pageSize="10" :total="total"
        :show-total="total => `共 ${total} 条`" @change="getData"></a-pagination> -->
      <div class="custom-page" style="float:right">
        <li @click="prevPage(customPage.pageNum)" title="上一页" class=" ant-pagination-prev" aria-disabled="false" tabindex="0"><a class="ant-pagination-item-link"><span role="img" aria-label="left" class="anticon anticon-left"><svg class="" data-icon="left" width="1em" height="1em" fill="currentColor" aria-hidden="true" viewBox="64 64 896 896" focusable="false"><path d="M724 218.3V141c0-6.7-7.7-10.4-12.9-6.3L260.3 486.8a31.86 31.86 0 000 50.3l450.8 352.1c5.3 4.1 12.9.4 12.9-6.3v-77.3c0-4.9-2.3-9.6-6.1-12.6l-360-281 360-281.1c3.8-3 6.1-7.7 6.1-12.6z"></path></svg></span></a></li>
        <li title="1" tabindex="0" class="bordernone ant-pagination-item ant-pagination-item-1">{{customPage.pageNum}}</li>
        <li @click="nextPage(customPage.pageNum)" title="下一页" class=" ant-pagination-next" aria-disabled="false" tabindex="0"><a class="ant-pagination-item-link"><span role="img" aria-label="right" class="anticon anticon-right"><svg class="" data-icon="right" width="1em" height="1em" fill="currentColor" aria-hidden="true" viewBox="64 64 896 896" focusable="false"><path d="M765.7 486.8L314.9 134.7A7.97 7.97 0 00302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 000-50.4z"></path></svg></span></a></li>
      </div>
    </a-card>
    <PreviewDialog ref="previewDialog" :list="carouselList" :defaultId="carouselPos"></PreviewDialog>
    <DetailDialog ref="detailDialog" :currentDataItem="currentDataItem" :attrTree="dataAttrData" :allTags="allTags"
      @update="getData" @updateTags="getAllTags" @cancel="closeDetail">
    </DetailDialog>
    <DataSetDialog ref="dataSetDialog" :basicAddition="searchedForm" :itemAddition="searchedItemAddition"
      :tagAddition="tagAddition" :attrAddition="attrAddition">
    </DataSetDialog>
  </div>
</template>
<script>
import { getDataByPage } from '@/api/dataItem'
import { getTagLabel } from '@/api/tagLabel'
import { getAllAttrCategory, getAttrValue, getAttrSubValue } from '@/api/dataAttr'
import { SearchOutlined } from '@ant-design/icons-vue'
import DataSetDialog from './DataSetDialog'
import PreviewDialog from './PreviewDialog'
import DetailDialog from './DetailDialog'
import { getDateTime, getDataTypeName } from '@/filters'
import config from '@/config'
// import moment from 'moment'
import { mapState } from 'vuex'
import { tsMethodSignature } from '@babel/types'
import { PlusOutlined } from '@ant-design/icons-vue';
import { message } from 'ant-design-vue';

let checkTimer = null

const columns = [
  {
    title: '上传ID',
    dataIndex: 'uploadRecordId'
  },
  {
    title: '数据ID',
    dataIndex: 'id'
  },
  {
    title: '数据类型',
    dataIndex: 'itemTypeId',
    slots: { customRender: 'itemType' }
  },
  {
    title: '上传时间',
    dataIndex: 'createTime',
    slots: { customRender: 'time' }
  },
  {
    title: '操作',
    slots: { customRender: 'action' }
  }
]
export default {
  components: {
    SearchOutlined,
    // DeleteOutlined,
    DataSetDialog,
    DetailDialog,
    PreviewDialog,
    PlusOutlined,
    message,
  },
  data () {
    return {
      btnPerm: config.btnPerm,
      searchloading:true,
      firstState:false,
      lastState:false,

      customPage:{
        pageNum: 1,
        pageSize: 10
      },
      page: {
        pageNum: 1,
        pageSize: 10
      },
      initialSearch: true,
      // 创建dataset时不用变化
      form: {
        minDate: null,
        maxDate: null,
        pageSizeMax: null
      },
      // 创建dataset时将变为item.xxx
      itemAddition: {
        itemTypeId: '',
        existDatasetState: '',
        uploadRecordId: '',
        autoClassficationTaskState: '',
        autoInstanceSegmentationTaskState: '',
        autoObjectDetectionTaskState: '',
        autoOtherAnnotationTaskState: '',
        autoPanopticSegmentationTaskState: '',
        autoPolygonTaskState: '',
        autoSemanticSegmentationTaskState: '',
        autoTagAnnotationTaskState: '',
        classficationTaskState: '',
        instanceSegmentationTaskState: '',
        objectDetectionTaskState: '',
        otherAnnotationTaskState: '',
        panopticSegmentationTaskState: '',
        polygonTaskState: '',
        semanticSegmentationTaskState: '',
        tagAnnotationTaskState: '',
        pointCloudAnnotationTaskState: '',
        speechAnnotationTaskState: '',
        textAnnotationTaskState: '',
        videoAnnotationTaskState: '',
        // labelNames:'',
        minLabelCount:'',
        maxLabelCount:'',  //todo
      },
      tagValue: [], // tag筛选
      attrValue: [], // 数据属性筛选
      tableData: [],
      columns,
      total: 0,
      carouselList: [],
      carouselPos: 0,
      currentDataItem: {},
      allTags: [],
      dataAttrData: [],
      searchedForm: {},
      searchedItemAddition: {},
      tagAddition: {},
      attrAddition: {},

      tags: [],
      labels:[],
      inputVisible: false,
      inputValue: '',
    }
  },
  computed: {
    ...mapState(['currentRole', 'dataTypeList'])
  },
  async mounted () {
    await this.getAllTags().catch(e => e)
    this.getDataAttr().catch(e => e)
    this.getDataNew(1)
  },
  beforeUnmount () {
    if (checkTimer) {
      clearTimeout(checkTimer)
      checkTimer = null
    }
  },
  methods: {
    getDataTypeName,
    getDateTime,
    changeTab (key) {},
    resetForm () {
      this.$refs.form.resetFields()
      this.tagValue = []
      this.attrValue = []
      this.itemAddition = {
        itemTypeId: '',
        existDatasetState: '',
        uploadRecordId: '',
        autoClassficationTaskState: '',
        autoPolygonTaskState: '',
        autoInstanceSegmentationTaskState: '',
        autoObjectDetectionTaskState: '',
        autoOtherAnnotationTaskState: '',
        autoPanopticSegmentationTaskState: '',
        autoSemanticSegmentationTaskState: '',
        autoTagAnnotationTaskState: '',
        classficationTaskState: '',
        polygonTaskState: '',
        instanceSegmentationTaskState: '',
        objectDetectionTaskState: '',
        otherAnnotationTaskState: '',
        panopticSegmentationTaskState: '',
        semanticSegmentationTaskState: '',
        tagAnnotationTaskState: '',
        pointCloudAnnotationTaskState: '',
        speechAnnotationTaskState: '',
        textAnnotationTaskState: '',
        videoAnnotationTaskState: ''
      }
    },
    getAllTags () {
      return getTagLabel().then(res => {
        this.allTags = res.data.map.data.rows
      })
    },

    valToId(val){
      if(val){
         let id = '';
        this.allTags.forEach((tagItem)=>{
          if(tagItem.chineseInstructions == val){
            id = tagItem.id
          }
        })
        return id
      }
     
    },

    getTagFilter () {
      let id = '';
      return Object.fromEntries(this.tagValue.map((val, index) => [
        `tags[${index}].id`, this.valToId(val) || ''
      ]))
    },
    async getDataAttr () {
      const res = await getAllAttrCategory().catch(e => e)

      this.dataAttrData = res.data.map.data
    },
    async getSubValue (value) {
      const data = value.map(i => ({
        ...i,
        title: i.chineseInstructions,
        value: i.id,
        key: i.id
      }))
      if (data.length) {
        for (const v of value.children) {
          v.children = this.getSubValue(v.children);
        }
      }
      return data;

    },
    getAttrFilter () {
      return Object.fromEntries(this.attrValue.map((id, index) => ([
        `itemValues[${index}].id`, id
      ])))
    },
    nextPage(pages){
      if(this.lastState){
         message.info('已经是最后一页了')
      }else{
        this.customPage.pageNum++;
        this.getDataNew(this.customPage.pageNum);
      }
    },
    prevPage(){
      if(this.customPage.pageNum > 1){
         this.customPage.pageNum--;
         this.lastState = false;
         this.getDataNew(this.customPage.pageNum);
      }else{
        message.info('已经是第一页了')
      }
    },
    searchHandle(){
      this.customPage.pageNum = 1;
      this.lastState = false;
      this.getDataNew(1);
    },
    closeDetail(){
      //this.currentDataItem = {}
    },
    getDataNew(pageNum){
     //if (pageNum) this.customPage.pageNum = pageNum
      this.tagAddition = this.getTagFilter()
      this.attrAddition = this.getAttrFilter()
      this.labelAttr = this.getlLabelAttr()
      this.searchedItemAddition = { ...this.itemAddition }
      this.searchedForm = { ...this.form }
      this.searchloading = true;
      getDataByPage({
        ...this.customPage,
        ...this.form,
        ...this.itemAddition,
        ...this.tagAddition,
        ...this.attrAddition,
        ...this.labelAttr
      }).then(res => {
        this.searchloading = false;
        const data = res.data.map.data
        this.total = data.total
        this.tableData = data.rows
        if(data && data.rows.length < this.customPage.pageSize){
          this.lastState = true; //最后一页
        }

        // if(data && data.rows.length < 1){
        //    this.lastState = true; //最后一页
        //    this.customPage.pageNum--;
        // }

        // if (!this.initialSearch && !this.form.pageSizeMax) {
        //   this.form.pageSizeMax = this.total
        // }
        this.initialSearch = false
   
        //this.resetCheckTimer()
      })
    },
    getData (pageNum) {
      if (pageNum) this.page.pageNum = pageNum
      this.tagAddition = this.getTagFilter()
      this.attrAddition = this.getAttrFilter()
      this.labelAttr = this.getlLabelAttr()
      this.searchedItemAddition = { ...this.itemAddition }
      this.searchedForm = { ...this.form }
      this.searchloading = true;
      getDataByPage({
        ...this.page,
        ...this.form,
        ...this.itemAddition,
        ...this.tagAddition,
        ...this.attrAddition,
        ...this.labelAttr
      }).then(res => {
        this.searchloading = false;
        const data = res.data.map.data
        this.total = data.total
        this.tableData = data.rows
        if (!this.initialSearch && !this.form.pageSizeMax) {
          this.form.pageSizeMax = this.total
        }
        this.initialSearch = false
        //this.resetCheckTimer()
      })
    },
    resetCheckTimer () {
      if (checkTimer) {
        clearTimeout(checkTimer)
      }
      checkTimer = setTimeout(() => {
        getDataByPage({
          pageNum: 1,
          pageSize: 10,
          ...this.searchedForm,
          ...this.searchedItemAddition,
          ...this.tagAddition,
          ...this.attrAddition
        }).then(res => {
          const data = res.data.map.data
          if (data.total === this.total) { // 数据未变化
            //this.resetCheckTimer()
          } else {
            this.$confirm({
              title: '数据变化',
              content: '数据已变化，请重新查询',
              okText: '是',
              cancelText: '否',
              onOk: () => {
                this.getData()
              },
              onCancel () {
                console.log('cancel')
              }
            })
          }
        })
      }, 10000)
    },
    handlePreview (item) {
      this.carouselList = [{
        id: item.id,
        url: item.accessSrc
      }]
      this.$refs.previewDialog.open()
    },
    // 查看数据
    openDetail (item) {
      this.currentDataItem = item
      this.$refs.detailDialog.valueAndParent = [];
      this.$refs.detailDialog.open()
    },
    // 创建数据集
    openAddDataSet () {
      this.searchedForm = { ...this.form }
      this.$refs.dataSetDialog.open()
    },
    numMaxCheck(e){
      if (this.itemAddition.maxLabelCount != '') {
        if (e.target.value > this.itemAddition.maxLabelCount) {
          this.itemAddition.minLabelCount = ''
        }
      }
    },
    numMinCheck(e) {
      if (this.itemAddition.minLabelCount != ''){
        if (e.target.value < this.itemAddition.minLabelCount) {
          this.itemAddition.maxLabelCount = ''
        }
      } 
    },
    handleClose(removedTag) {
      const tags = this.tags.filter(tag => tag !== removedTag);
      console.log(tags);
      this.tags = tags;
    },

    showInput() {
      this.inputVisible = true;
      this.$nextTick(function () {
        this.$refs.input.focus();
      });
    },

    handleInputChange(e) {
      this.inputValue = e.target.value;
    },

    handleInputConfirm() {
      const inputValue = this.inputValue;
      let tags = this.tags;
      if (inputValue && tags.indexOf(inputValue) === -1) {
        tags = [...tags, inputValue];
      }
      console.log(tags);
      Object.assign(this, {
        tags,
        inputVisible: false,
        inputValue: '',
      });
    },
    getlLabelAttr() {
      return Object.fromEntries(this.labels.map((label, index) => ([
        `labelNames[${index}]`, label
      ])))
    },
  }
}
</script>
<style lang="less">
.filter-collapse {
  width: 1280px;
  .ant-form-item {
    .ant-form-item-label {
      width: 150px;
    }
  }
}

.custom-page .bordernone{
  border-color: #efefef;
  background:#efefef;
}
.custom-page .bordernone:hover{
  border-color: #efefef;
  background:#efefef;
  cursor: inherit;
}
.dataform-search .ant-form-item{
  margin-bottom: 10px;
}
</style>
